<template>
	<teleport to="#desktop-modal">
		<div class="modal">
			<div class="modal-content">
				<slot></slot>
			</div>
		</div>
	</teleport>
</template>

<script setup></script>

<style scoped></style>
